<template>
  <div class='col-sm-12'>
    <div class="box box-solid">
      <div class="box-header with-border">
        <i class="fa fa-area-chart"></i>
        <h3 class="box-title">{{'merchant_stats' | translate}}</h3>
        <div class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        </div>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <div class="input-group">
              <input class="form-control" type="text" v-model="filterValue" @blur="filter" @keyup.prevent="filter" :placeholder="`${$options.filters.translate('company', $store.getters.language)}...`">
              <div class="input-group-btn">
                <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-body" style="display: block;">
        <div class="table-responsive">
          <table class="table no-margin table-hover table-striped">
            <thead>
            <tr>
              <th>{{'merchant' | translate}}</th>
              <th @click="sort('order')"><i :class="['fa', orderDesc ? 'fa-sort-numeric-desc' : 'fa-sort-numeric-asc', 'mr-5']"></i>{{'orders' | translate}}</th>
              <th>{{'cancellations' | translate}}</th>
              <th @click="sort('cancel')"><i :class="['fa', cancelDesc ? 'fa-sort-numeric-desc' : 'fa-sort-numeric-asc', 'mr-5']"></i>{{'cancellation_ratio' | translate}}</th>
              <th>{{'items' | translate}}</th>
              <th>{{'order_avg' | translate}} %</th>
              <th class="text-right">{{'amount' | translate}}</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="merchant in filterData">
              <tr>
                <td>
                  <router-link :to="'/accounting/companies/' + merchant.id">{{merchant.company}}</router-link>
                </td>
                <td>
                  {{merchant.orders}}
                </td>
                <td>
                  {{merchant.cancelled}}
                </td>
                <td>
                  {{merchant.cancelRatio}}
                </td>
                <td>
                  {{merchant.items}}
                </td>
                <td>
                  {{merchant.average | currency}}
                </td>
                <td class="text-right">
                  {{merchant.amount | currency}}
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: ['merchantData', 'originalData'],
  data () {
    return {
    	filterValue: '',
      filterData: this.merchantData,
      cancelDesc: true,
      orderDesc: true,
      cancelSorting: false,
    }
  },
  methods: {
  	filter () {
      if (this.filterValue !== '') {
	      this.filterData = this.originalData.filter(el => {
	      	let regex = new RegExp(eval(`/${this.filterValue}.*/i`))
          return el.company.match(regex)
	      })
      } else {
  			this.filterData = this.originalData
      }
	  },
    sort(type) {
      if (type === 'cancel') {
        if (this.cancelSorting) {
          this.cancelDesc = !this.cancelDesc
          this.filterData.reverse()
        } else {
          this.filterData.sort((a, b) => a.cancelRatio - b.cancelRatio)
          if (!this.cancelDesc) {
            this.cancelDesc = true
          }
          this.cancelSorting = true
        }
      } else {
        if (this.cancelSorting) this.cancelSorting = false
        this.orderDesc = !this.orderDesc
        this.filterData.reverse()
      }
    },
    calculateTime () {
      let time = Math.ceil(moment().diff(moment().startOf('hour'), 'minutes') / 5)
      time++
      time = time + ((time - 1) * 4)
      let callback = moment().minutes(time).seconds(0)
      return (callback.diff(moment().seconds(0), 'miliseconds'))
    }
  },
  computed: {
  },
  watch: {
		originalData () {},
    merchantData () {
			this.filterData = this.merchantData
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/MerchantBoxesComponent.vue